import { Modal, Form, Input, Button } from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useEffect, useState } from "react";

const EditTemplateModal = ({ template, onCancel, onSave, isSending }) => {
  const [form] = Form.useForm();
  const [content, setContent] = useState("");

  useEffect(() => {
    if (template) {
      form.setFieldsValue({ title: template.title });
      setContent(template.description);
    }
  }, [template, form]);

  const handleSubmit = async () => {
    try {
      const title = form.getFieldValue("title");
      if (!title) throw new Error("Title is required");
      if (!content || content === "<p><br></p>") throw new Error("Content is required");

      const success = await onSave(template._id, {
        title,
        description: content,
        position: template.position,
      });

      if (success) {
        onCancel();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"],
    ],
  };
  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
  ];

  return (
    <Modal
      title="Edit Template"
      open={!!template}
      onCancel={onCancel}
      width={800}
      footer={[
        <Button key="back" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleSubmit}
          loading={isSending}
        >
          Update
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="title"
          label="Title"
          rules={[{ required: true, message: "Please input the title!" }]}
        >
          <Input placeholder="Enter title" />
        </Form.Item>
        <Form.Item
          label="Content"
          required
          validateStatus={!content || content === "<p><br></p>" ? "error" : ""}
          help={!content || content === "<p><br></p>" ? "Please input the content!" : ""}
        >
          <ReactQuill
            theme="snow"
            value={content}
            onChange={setContent}
            modules={modules}
            formats={formats}
            placeholder="Enter content..."
            style={{ height: "300px", marginBottom: "40px" }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditTemplateModal;